// src/components/mediaKit/AmazonHlsPlayer.jsx
import React, { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';

export default function AmazonHlsPlayer({ src }) {
    const videoRef = useRef(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        const video = videoRef.current;
        if (!video || !src) return;

        if (video.canPlayType('application/vnd.apple.mpegurl')) {
            // Safari: native HLS support
            video.src = src;
            return;
        }

        if (Hls.isSupported()) {
            const hls = new Hls();
            hls.loadSource(src);
            hls.attachMedia(video);
            hls.on(Hls.Events.ERROR, (_, data) => { if (data.fatal) setError(true); });
            return () => hls.destroy();
        }

        setError(true);
    }, [src]);

    if (error) {
        return (
            <div className="aspect-video flex items-center justify-center bg-black text-white text-sm">
                This video can't be played here.
            </div>
        );
    }

    return <video ref={videoRef} controls autoPlay className="w-full aspect-video bg-black" />;
}